// extracted by mini-css-extract-plugin
export default {"content":"Schedule_content__dXuWS","container":"Schedule_container__h+eG7","islandsGroup":"Schedule_islandsGroup__WoKld"};